import { useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

function useFetchReferralMovements(accessToken) {
  const { url } = useDataContext();
  const [referralMovements, setReferralMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accessToken || !url) return;
    setLoading(true);
    setError(null);

    const fetchReferralMovements = async () => {
      try {
        const response = await axios.get(`${url}/ReferralBonus/withPersonality`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setReferralMovements(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchReferralMovements();
  }, [accessToken, url]);

  return { referralMovements, loading, error };
}

export { useFetchReferralMovements };
